<div
  class="date-picker input input--icon"
  [ngClass]="{
    'input--highlight': !!(highlightError | async),
    'input--invalid': showValidation && !control.valid,
    'input--touched': control.touched || submitAttempted
  }"
>
  <ftr-icon class="input__icon" icon="Event"></ftr-icon>
  <input
    #datePicker
    [id]="id"
    name="datePicker"
    class="date-picker__control input__control"
    [ngClass]="{ 'input__control--has-value': hasValue }"
    [required]="required"
    [placeholder]="placeholder"
    [attr.aria-label]="ariaLabel || label"
    autocomplete="off"
    (blur)="onInputElementBlur($event)"
    (keydown.enter)="onInputElementKeyDown($event)"
  />
  @if (clearDate && hasValue) {
    <a
      class="input__search-clear"
      type="button"
      ftrButton
      ftrStopPropagation
      [displayType]="buttonDisplayType.Text"
      href="javascript:void(0)"
      (click)="onClear()"
    >
      <ftr-icon icon="Close" color="GreyLight"></ftr-icon>
    </a>
  }
  <label class="input__label" [htmlFor]="id" [ngClass]="{ 'input__label--required': required }">{{ label }}</label>
  <span class="input__bar"></span>
  @if (showValidation) {
    <span
      class="input__validation"
      ftrValidationErrorHint
      [label]="label"
      [ngFormControl]="control"
      [controlTouched]="control.touched"
      [submitAttempted]="submitAttempted"
    ></span>
  }
</div>
